import { Pipe, PipeTransform } from '@angular/core';

import { AddressConstants } from '../../modules/address/address.constants';

@Pipe({
	name: 'statelabel',
})
export class StateLabelPipe implements PipeTransform {
	transform(value?: string | null): string {
		if (!value) {
			return '';
		}

		return (
			AddressConstants.ufLabels.find((option) => option.uf === value)?.label ||
			''
		);
	}
}
/* eslint-disable typescript-extended-rules/file-naming-convention */
